import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { io, Socket } from "socket.io-client";
import { Message } from "../../interfaces/interfaces";
import { addSingleMessageReceived } from "../../redux/chat/chatSlice";
import { fetchAsyncMessages } from "../../redux/chat/chatUtil";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import { getLocalJWT, getLocalUserId, logout } from "../functions/utilities";
import { socketInit } from "./socketInit";

export const useSocket = (userId: string) => {
  // console.log(userId);
  const navigate = useNavigate();
  const socket = useRef(null);
  const currentUserId = getLocalUserId();
  const token = getLocalJWT();
  const dispatch = useAppDispatch();
  const { messagesLoadedChannels, joinNewChannelTrigger } = useAppSelector(
    (state) => state.chatState
  );

  useEffect(() => {
    socket.current = socketInit(userId, token);

    socket.current.on("connect", () => {
      // console.log("connected");
    });

    socket.current.on("MESSAGE_RECEIVED", (message) => {
      // console.log("message payload", message);
      let data = message["data"] as Message;

      // console.log(data, messagesLoadedChannels);
      // if (messagesLoadedChannels[`${data.channelId}`] === undefined) {
      dispatch(
        fetchAsyncMessages({
          channelId: data.channelId,
          message: data,
          userId: currentUserId,
        })
      );
      // } else {
      //   dispatch(
      //     addSingleMessageReceived({
      //       message: data,
      //       channelId: data.channelId,
      //       userId: currentUserId,
      //     })
      //   );
      // }
    });

    socket.current.on("MESSAGE_ACK", (message) => {
      let data = message["data"] as Message;
      dispatch(
        addSingleMessageReceived({
          message: data,
          channelId: data.channelId,
          userId: currentUserId,
        })
      );
    });

    socket.current.on("unauthorized", (message) => {
      console.log("unauthorized error", message);
      logout();
      navigateToLogin();
    });

    socket.current.on("connect_error", (err) => {
      console.log("connect error", err);
    });

    return () => {
      socket.current.disconnect();
    };
  }, []);

  const handleJoinRoom = (roomIds: string[]) => {
    // console.log(roomIds);
    if (socket.current && roomIds.length > 0) {
      socket.current.emit("JOIN_CHANNEL", { channelId: roomIds });
    }
  };

  useEffect(() => {
    if (joinNewChannelTrigger !== null && socket.current) {
      // console.log("triggering join channel");
      socket.current.emit("JOIN_CHANNEL", {
        channelId: [joinNewChannelTrigger],
      });
    }
  }, [joinNewChannelTrigger]);

  const navigateToLogin = () => {
    navigate("/login");
  };

  return {
    socket: socket.current,
    handleJoinRoom,
  };
};
